(function () {
    'use strict';

    function initHolidaySalaryCalculators(context) {
        const calculators = (context || document).querySelectorAll('[data-component="holiday-salary-calculator"]');

        calculators.forEach(calculator => {
            const ageInput = calculator.querySelector('#calc-age-slider');
            const hoursInput = calculator.querySelector('#calc-hours-slider');

            const resultText = calculator.querySelector('[data-result-text]');
            const hourlyResult = calculator.querySelector('[data-result-hourly]');
            const weeklyResult = calculator.querySelector('[data-result-weekly]');

            // Basis salarissen voor alle mogelijke leeftijden
            const seventeenOrLess = calculator.dataset.seventeenOrLess;
            const eighteen = calculator.dataset.eighteen;
            const nineteen = calculator.dataset.nineteen;
            const twentyOrMore = calculator.dataset.twentyOrMore;

            if (!ageInput || !hoursInput || !seventeenOrLess || !eighteen || !nineteen || !twentyOrMore) return;

            function calculateAndDisplay() {
                const age = parseInt(ageInput.value, 10);
                const hours = parseInt(hoursInput.value, 10);
                
                // Bepaal het uurloon op basis van leeftijd
                let hourlyWage;
                if (age <= 17) {
                    hourlyWage = seventeenOrLess;
                }
                else if (age == 18) {
                    hourlyWage = eighteen;
                }
                else if (age == 19) {
                    hourlyWage = nineteen;
                }
                else {
                    hourlyWage = twentyOrMore;
                }

                hourlyWage = Number(hourlyWage.replace(',', '.'));

                const weeklyWage = hourlyWage * hours;

                if (resultText) {
                    resultText.textContent = `Wanneer je ${hours} uur per week werkt en je bent ${age} jaar oud, dan verdien je per uur:`;
                }
                
                if (hourlyResult) {
                    hourlyResult.textContent = `€${hourlyWage.toFixed(2)}`;
                }
                
                if (weeklyResult) {
                    weeklyResult.textContent = `€${weeklyWage.toFixed(2)}`;
                }
            }

            ageInput.addEventListener('input', calculateAndDisplay);
            hoursInput.addEventListener('input', calculateAndDisplay);

            // Initial calculation
            calculateAndDisplay();
        });
    }

    // Initial load
    initHolidaySalaryCalculators();

    // Expose to global scope for re-initialization if needed
    window.initHolidaySalaryCalculators = initHolidaySalaryCalculators;

})();
